import React from 'react';
import Header from './Header';
import Footer from './Footer';

const CookiePolicy: React.FC = () => (
  <div className="page-container">
    <Header />
    <main className="page-content">
      <h1>Cookie Policy</h1>
      <p>
        Consphic uses cookies to enhance your browsing experience and analyze site traffic. Cookies help us understand how you interact with our website and allow us to improve our services. You can manage your cookie preferences at any time. For more information, please review this policy or contact our support team.
      </p>
    </main>
    <Footer />
  </div>
);

export default CookiePolicy;
